export default "__VITE_ASSET__BnDPmAIq__"